"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escape_html_1 = __importDefault(require("escape-html"));
var util_1 = require("./util");
var RenderUploadFile = /** @class */ (function () {
    function RenderUploadFile(_a) {
        var parent = _a.parent, input = _a.input, skipRequired = _a.skipRequired, translations = _a.translations;
        this.createFilesContainer = function (parent) {
            var div = document.createElement("div");
            div.className = "dff-files";
            parent.appendChild(div);
            return div;
        };
        this.container = this.createFilesContainer(parent);
        this.input = input;
        this.translations = translations;
        if (skipRequired) {
            this.input.required = false;
        }
    }
    RenderUploadFile.prototype.addUploadedFile = function (filename, uploadIndex, filesize) {
        var element = this.addFile(filename, uploadIndex);
        this.setSuccess(uploadIndex, filesize);
        return element;
    };
    RenderUploadFile.prototype.addNewUpload = function (filename, uploadIndex) {
        var div = this.addFile(filename, uploadIndex);
        var progressSpan = document.createElement("span");
        progressSpan.className = "dff-progress";
        var innerSpan = document.createElement("span");
        innerSpan.className = "dff-progress-inner";
        progressSpan.appendChild(innerSpan);
        div.appendChild(progressSpan);
        var cancelLink = document.createElement("a");
        cancelLink.className = "dff-cancel";
        cancelLink.innerHTML = this.translations.Cancel;
        cancelLink.setAttribute("data-index", "".concat(uploadIndex));
        cancelLink.href = "#";
        div.appendChild(cancelLink);
        return div;
    };
    RenderUploadFile.prototype.addFile = function (filename, uploadIndex) {
        var div = document.createElement("div");
        div.className = "dff-file dff-file-id-".concat(uploadIndex);
        var nameSpan = document.createElement("span");
        nameSpan.innerHTML = (0, escape_html_1.default)(filename);
        div.appendChild(nameSpan);
        this.container.appendChild(div);
        this.input.required = false;
        return div;
    };
    RenderUploadFile.prototype.deleteFile = function (index) {
        var div = this.findFileDiv(index);
        if (div) {
            div.remove();
        }
    };
    RenderUploadFile.prototype.setError = function (index) {
        var span = document.createElement("span");
        span.classList.add("dff-error");
        span.innerHTML = this.translations["Upload failed"];
        var el = this.findFileDiv(index);
        if (el) {
            el.appendChild(span);
            el.classList.add("dff-upload-fail");
        }
        this.removeProgress(index);
        this.removeCancel(index);
    };
    RenderUploadFile.prototype.setDeleteFailed = function (index) {
        var el = this.findFileDiv(index);
        if (el) {
            var span = document.createElement("span");
            span.innerHTML = this.translations["Delete failed"];
            el.appendChild(span);
        }
        this.enableDelete(index);
    };
    RenderUploadFile.prototype.findFileDiv = function (index) {
        return this.container.querySelector(".dff-file-id-".concat(index));
    };
    RenderUploadFile.prototype.setSuccess = function (index, size) {
        var translations = this.translations;
        var el = this.findFileDiv(index);
        if (el) {
            el.classList.add("dff-upload-success");
            var fileSizeInfo = document.createElement("span");
            fileSizeInfo.innerHTML = (0, util_1.formatBytes)(size, 2);
            fileSizeInfo.className = "dff-filesize";
            el.appendChild(fileSizeInfo);
            var deleteLink = document.createElement("a");
            deleteLink.innerHTML = translations.Delete;
            deleteLink.className = "dff-delete";
            deleteLink.setAttribute("data-index", "".concat(index));
            deleteLink.href = "#";
            el.appendChild(deleteLink);
        }
        this.removeProgress(index);
        this.removeCancel(index);
    };
    RenderUploadFile.prototype.removeProgress = function (index) {
        var el = this.findFileDiv(index);
        if (el) {
            var progressSpan = el.querySelector(".dff-progress");
            if (progressSpan) {
                progressSpan.remove();
            }
        }
    };
    RenderUploadFile.prototype.removeCancel = function (index) {
        var el = this.findFileDiv(index);
        if (el) {
            var cancelSpan = el.querySelector(".dff-cancel");
            if (cancelSpan) {
                cancelSpan.remove();
            }
        }
    };
    RenderUploadFile.prototype.clearInput = function () {
        var input = this.input;
        input.value = "";
    };
    RenderUploadFile.prototype.updateProgress = function (index, percentage) {
        var el = this.container.querySelector(".dff-file-id-".concat(index));
        if (el) {
            var innerProgressSpan = el.querySelector(".dff-progress-inner");
            if (innerProgressSpan) {
                innerProgressSpan.style.width = "".concat(percentage, "%");
                innerProgressSpan.innerText = "".concat(percentage, "%");
            }
        }
    };
    RenderUploadFile.prototype.renderDropHint = function () {
        if (this.container.querySelector(".dff-drop-hint")) {
            return;
        }
        var dropHint = document.createElement("div");
        dropHint.className = "dff-drop-hint";
        dropHint.innerHTML = this.translations["Drop your files here"];
        this.container.appendChild(dropHint);
    };
    RenderUploadFile.prototype.removeDropHint = function () {
        var dropHint = this.container.querySelector(".dff-drop-hint");
        if (dropHint) {
            dropHint.remove();
        }
    };
    RenderUploadFile.prototype.disableDelete = function (index) {
        var deleteLink = this.findDeleteLink(index);
        if (deleteLink) {
            deleteLink.classList.add("dff-disabled");
        }
    };
    RenderUploadFile.prototype.enableDelete = function (index) {
        var deleteLink = this.findDeleteLink(index);
        if (deleteLink) {
            deleteLink.classList.remove("dff-disabled");
        }
    };
    RenderUploadFile.prototype.findDeleteLink = function (index) {
        var div = this.findFileDiv(index);
        if (!div) {
            return div;
        }
        return div.querySelector(".dff-delete");
    };
    return RenderUploadFile;
}());
exports.default = RenderUploadFile;
